import { EmailInput, NameInput, NameWithPrefixInput, PhoneInput, RoleInput } from "components/Form/inputs";
import { useTranslation } from "react-i18next";
import { pocFieldConfigs } from "../../utils/addPocControl/pocFieldConfig";

export const FilterInputs = ({ status, get }) => {
  const { t } = useTranslation("form");
    switch (status) {
        case 'first_name_prefix':
            return (<NameWithPrefixInput label={t("firstName")} placeholder={t("firstName")} id="first" />);
        case 'first_name':
            return (<NameInput label={t("firstName")} placeholder={t("firstName")} id="first" />);
        case 'last_name':
            return (<NameInput label={t("lastName")} placeholder={t("lastName")} id="last" />);
        case 'email':
            return (<EmailInput />);
        case 'phone':
            return (<PhoneInput get={get} disableCountryCode={!!pocFieldConfigs.countryCode.disabled} />);
        case 'role':
            return (<RoleInput />);
        default:
            return <></>;
    }
}